module.exports = __webpack_public_path__ + "static/img/doctor-bg.3aceb36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shapes/doctor-bg.jpg
// module id = LIyH
// module chunks = 7